"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const CarbonTx = __importStar(require("../../../util/tx"));
const utils_1 = require("../utils");
const TxTypes = {
    SupplyAsset: "cdp/SupplyAsset",
    WithdrawAsset: "cdp/WithdrawAsset",
    LockCollateral: "cdp/LockCollateral",
    UnlockCollateral: "cdp/UnlockCollateral",
    BorrowAsset: "cdp/BorrowAsset",
    RepayAsset: "cdp/RepayAsset",
    SupplyAssetAndLockCollateral: "cdp/SupplyAssetAndLockCollateral",
    UnlockCollateralAndWithdrawAsset: "cdp/UnlockCollateralAndWithdrawAsset",
    LiquidateCollateral: "cdp/LiquidateCollateral",
    MintStablecoin: "cdp/MintStablecoin",
    ReturnStablecoin: "cdp/ReturnStablecoin",
    CreateRewardScheme: "cdp/CreateRewardScheme",
    UpdateRewardScheme: "cdp/UpdateRewardScheme",
    SetStablecoinMintCap: "cdp/SetStablecoinMintCap",
    SetStalePriceGracePeriod: "cdp/SetStalePriceGracePeriod",
    SetCdpPaused: "cdp/SetCdpPaused",
    ClaimRewards: "cdp/ClaimRewards",
    AddEModeCategory: "cdp/AddEModeCategory",
    UpdateEModeCategory: "cdp/UpdateEModeCategory",
    SetAccountEMode: "cdp/SetAccountEMode",
    RemoveAccountEMode: "cdp/RemoveAccountEMode",
};
const MsgSupplyAsset = {
    aminoType: TxTypes.SupplyAsset,
    valueMap: {},
};
const MsgWithdrawAsset = {
    aminoType: TxTypes.WithdrawAsset,
    valueMap: {},
};
const MsgLockCollateral = {
    aminoType: TxTypes.LockCollateral,
    valueMap: {},
};
const MsgUnlockCollateral = {
    aminoType: TxTypes.UnlockCollateral,
    valueMap: {},
};
const MsgBorrowAsset = {
    aminoType: TxTypes.BorrowAsset,
    valueMap: {},
};
const MsgRepayAsset = {
    aminoType: TxTypes.RepayAsset,
    valueMap: {},
};
const MsgSupplyAssetAndLockCollateral = {
    aminoType: TxTypes.SupplyAssetAndLockCollateral,
    valueMap: {},
};
const MsgUnlockCollateralAndWithdrawAsset = {
    aminoType: TxTypes.UnlockCollateralAndWithdrawAsset,
    valueMap: {},
};
const MsgLiquidateCollateral = {
    aminoType: TxTypes.LiquidateCollateral,
    valueMap: {},
};
const MsgMintStablecoin = {
    aminoType: TxTypes.MintStablecoin,
    valueMap: {},
};
const MsgReturnStablecoin = {
    aminoType: TxTypes.ReturnStablecoin,
    valueMap: {},
};
const MsgCreateRewardScheme = {
    aminoType: TxTypes.CreateRewardScheme,
    valueMap: {
        createRewardSchemeParams: {
            startTime: utils_1.ConvertEncType.Date,
            endTime: utils_1.ConvertEncType.Date,
        },
    },
};
const MsgUpdateRewardScheme = {
    aminoType: TxTypes.UpdateRewardScheme,
    valueMap: {
        updateRewardSchemeParams: {
            rewardSchemeId: utils_1.ConvertEncType.Long,
            startTime: utils_1.ConvertEncType.Date,
            endTime: utils_1.ConvertEncType.Date,
        },
    },
};
const MsgClaimRewards = {
    aminoType: TxTypes.ClaimRewards,
    valueMap: {},
};
const MsgSetStablecoinMintCap = {
    aminoType: TxTypes.SetStablecoinMintCap,
    valueMap: {},
};
const MsgSetStalePriceGracePeriod = {
    aminoType: TxTypes.SetStalePriceGracePeriod,
    valueMap: {
        stalePriceGracePeriod: utils_1.ConvertEncType.Duration,
    },
};
const MsgSetCdpPaused = {
    aminoType: TxTypes.SetCdpPaused,
    valueMap: {},
};
const MsgAddEModeCategory = {
    aminoType: TxTypes.AddEModeCategory,
    valueMap: {},
};
const MsgUpdateEModeCategory = {
    aminoType: TxTypes.UpdateEModeCategory,
    valueMap: {
        updateEModeCategoryParams: {
            loanToValue: utils_1.ConvertEncType.Long,
            liquidationThreshold: utils_1.ConvertEncType.Long,
            liquidationDiscount: utils_1.ConvertEncType.Long,
        },
    },
};
const MsgSetAccountEMode = {
    aminoType: TxTypes.SetAccountEMode,
    valueMap: {},
};
const MsgRemoveAccountEMode = {
    aminoType: TxTypes.RemoveAccountEMode,
    valueMap: {},
};
const CdpAmino = {
    [CarbonTx.Types.MsgSupplyAsset]: (0, utils_1.generateAminoType)(MsgSupplyAsset),
    [CarbonTx.Types.MsgWithdrawAsset]: (0, utils_1.generateAminoType)(MsgWithdrawAsset),
    [CarbonTx.Types.MsgLockCollateral]: (0, utils_1.generateAminoType)(MsgLockCollateral),
    [CarbonTx.Types.MsgUnlockCollateral]: (0, utils_1.generateAminoType)(MsgUnlockCollateral),
    [CarbonTx.Types.MsgBorrowAsset]: (0, utils_1.generateAminoType)(MsgBorrowAsset),
    [CarbonTx.Types.MsgRepayAsset]: (0, utils_1.generateAminoType)(MsgRepayAsset),
    [CarbonTx.Types.MsgSupplyAssetAndLockCollateral]: (0, utils_1.generateAminoType)(MsgSupplyAssetAndLockCollateral),
    [CarbonTx.Types.MsgUnlockCollateralAndWithdrawAsset]: (0, utils_1.generateAminoType)(MsgUnlockCollateralAndWithdrawAsset),
    [CarbonTx.Types.MsgLiquidateCollateral]: (0, utils_1.generateAminoType)(MsgLiquidateCollateral),
    [CarbonTx.Types.MsgMintStablecoin]: (0, utils_1.generateAminoType)(MsgMintStablecoin),
    [CarbonTx.Types.MsgReturnStablecoin]: (0, utils_1.generateAminoType)(MsgReturnStablecoin),
    [CarbonTx.Types.MsgCreateRewardScheme]: (0, utils_1.generateAminoType)(MsgCreateRewardScheme),
    [CarbonTx.Types.MsgUpdateRewardScheme]: (0, utils_1.generateAminoType)(MsgUpdateRewardScheme),
    [CarbonTx.Types.MsgClaimRewards]: (0, utils_1.generateAminoType)(MsgClaimRewards),
    [CarbonTx.Types.MsgSetStablecoinMintCap]: (0, utils_1.generateAminoType)(MsgSetStablecoinMintCap),
    [CarbonTx.Types.MsgSetStalePriceGracePeriod]: (0, utils_1.generateAminoType)(MsgSetStalePriceGracePeriod),
    [CarbonTx.Types.MsgSetCdpPaused]: (0, utils_1.generateAminoType)(MsgSetCdpPaused),
    [CarbonTx.Types.MsgAddEModeCategory]: (0, utils_1.generateAminoType)(MsgAddEModeCategory),
    [CarbonTx.Types.MsgUpdateEModeCategory]: (0, utils_1.generateAminoType)(MsgUpdateEModeCategory),
    [CarbonTx.Types.MsgSetAccountEMode]: (0, utils_1.generateAminoType)(MsgSetAccountEMode),
    [CarbonTx.Types.MsgRemoveAccountEMode]: (0, utils_1.generateAminoType)(MsgRemoveAccountEMode),
};
exports.default = CdpAmino;
